class RefreshOnNewBuildService {
  /**
   * Fetches version.json from the server
   * @returns
   *  the version string or empty string
   */
  static tryGetVersion = async (): Promise<{
    version: string;
    success: boolean;
  }> => {
    try {
      const response = await fetch("/version.json", {
        cache: "no-store"
      });

      if (!response.ok) {
        return { version: "", success: false };
      }

      const contentType = response.headers.get("content-type") || "";

      if (!contentType.includes("application/json")) {
        return { version: "", success: false };
      }

      const data = await response.json();

      const version = typeof data?.version === "string" ? data.version : "";

      return {
        version,
        success: version !== ""
      };
    } catch (error) {
      console.error("Failed to fetch version.json:", error);
      return { version: "", success: false };
    }
  };

  /**
   * Determines if refresh is required
   */
  static shouldForceRefresh = async (oldVersion: string): Promise<boolean> => {
    const { version, success } = await this.tryGetVersion();

    // If version is unavailable then do nothing, keep retrying later
    if (!success) return false;

    return oldVersion !== "" && oldVersion !== version;
  };

  /**
   * Clears caches and reloads the app
   */
  static forceReload = async () => {
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    window.location.reload();
  };
}

export default RefreshOnNewBuildService;
